<h5 class="text-lg font-semibold mb-4">Flashcard Information</h5>
<form [formGroup]="flashcardForm" class="space-y-6">
  <div class="flex flex-col sm:flex-row gap-4">
    <div class="flex-1">
      <label for="name" class="block text-sm font-medium text-gray-700 mb-1">Name</label>
      <input id="name" type="text" pInputText formControlName="name" placeholder="Enter flashcard name" class="w-full" />
    </div>

    <div class="flex-1">
      <label for="tag" class="block text-sm font-medium text-gray-700 mb-1">Tag</label>
      <input id="tag" type="text" pInputText formControlName="tag" placeholder="Enter flashcard tag" class="w-full" />
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <!-- Front Side Column -->
    <div class="space-y-4 p-4 border border-gray-200 rounded-md">
      <h3 class="text-md font-semibold">Front Side</h3>
      <div class="relative aspect-video bg-gray-100 rounded overflow-hidden">
        <img class="object-contain w-full h-full" [src]="frontUrl" alt="Front side image" />
        @if(storageImgSettings) {
        <div class="absolute bottom-2 left-2">
          <dc-cropper-modal
            buttonLabel="Seleccionar frente"
            [imgStorageSettings]="storageImgSettings"
            (imageUploaded)="updateUploadedImage($event, 'front')"></dc-cropper-modal>
        </div>
        }
      </div>

      <div formGroupName="front" class="space-y-4">
        <div>
          <label for="front-type" class="block text-sm font-medium text-gray-700 mb-1">Content Type</label>
          <p-dropdown
            inputId="front-type"
            [options]="contentTypes"
            formControlName="type"
            optionLabel="label"
            optionValue="value"
            placeholder="Select content type"
            styleClass="w-full"></p-dropdown>
          <!-- Use styleClass for PrimeNG components with Tailwind -->
        </div>
        <div>
          <label for="front-content" class="block text-sm font-medium text-gray-700 mb-1">Content</label>
          <textarea id="front-content" pTextarea formControlName="content" rows="3" class="w-full" placeholder="Enter front content"></textarea>
        </div>
      </div>
    </div>

    <!-- Back Side Column -->
    <div class="space-y-4 p-4 border border-gray-200 rounded-md">
      <h3 class="text-md font-semibold">Back Side</h3>
      <div class="relative aspect-video bg-gray-100 rounded overflow-hidden">
        <img class="object-contain w-full h-full" [src]="backUrl" alt="Back side image" />
        @if(storageImgSettings) {
        <div class="absolute bottom-2 left-2">
          <dc-cropper-modal
            buttonLabel="Seleccionar reverso"
            [imgStorageSettings]="storageImgSettings"
            (imageUploaded)="updateUploadedImage($event, 'back')"></dc-cropper-modal>
        </div>
        }
      </div>

      <div formGroupName="back" class="space-y-4">
        <div>
          <label for="back-type" class="block text-sm font-medium text-gray-700 mb-1">Content Type</label>
          <p-dropdown
            inputId="back-type"
            [options]="contentTypes"
            formControlName="type"
            optionLabel="label"
            optionValue="value"
            placeholder="Select content type"
            styleClass="w-full"></p-dropdown>
          <!-- Use styleClass for PrimeNG components with Tailwind -->
        </div>
        <div>
          <label for="back-content" class="block text-sm font-medium text-gray-700 mb-1">Content</label>
          <textarea id="back-content" pTextarea formControlName="content" rows="3" class="w-full" placeholder="Enter back content"></textarea>
        </div>
      </div>
    </div>
  </div>

  <div class="flex justify-end pt-4">
    <p-button (click)="save()" label="Save Flashcard" [disabled]="!flashcardForm.valid" icon="pi pi-check" iconPos="right"></p-button>
  </div>
</form>
